import { AD_CREATION_FAILED_STATUS, MODERATION_STATUSES, AD_STATES } from "../components/core/blocks/AdPlan/constants";

const AD_STATE_DISPLAY = {
  [AD_STATES.PAUSE.value]: ($) => $.advertising["Paused"],
  [AD_STATES.ACTIVE.value]: ($) => $.advertising["Active"],
  [AD_STATES.ARCHIVE.value]: ($) => $.advertising["Archived"],
  [AD_STATES.ENDED.value]: ($) => $.advertising["Ended"],
};

const MODERATION_DISPLAY = {
  [MODERATION_STATUSES.FAILED.value]: ($) => $.advertising["Failed"],
  [MODERATION_STATUSES.PENDING.value]: ($) => $.advertising["Pending"],
};

export const displayAdStatus = (state, adStatus) => {
  if (adStatus === AD_CREATION_FAILED_STATUS) {
    return ($) => $.advertising["Failed"];
  }
  if (adStatus in MODERATION_DISPLAY) {
    return MODERATION_DISPLAY[adStatus];
  }
  return AD_STATE_DISPLAY[state] ?? null;
};
